import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sentPayslipInfo,
// 已经发送-payslip info
getPayslipSentState, sentPayslipStaffList as _sentPayslipStaffList, afreshSendErrStaff,
// 重新发送
getAfreshSendStatus // 重新发送状态
} from '@/api/payroll/pay-slip';
export default {
  data: function data() {
    return {
      // 筛选项
      query: {
        search_name: '',
        // 搜索名字
        send_status: '2',
        // 发送状态
        payslip_id: this.$route.params.id // 已发送数据id
      },

      payslipInfo: {
        name: '',
        send_count: '',
        send_fail_count: '',
        send_success_count: ''
      },
      clearTime: null,
      // 定时器
      payState: {
        state: null,
        is_self_task: null
      },
      tableData: []
    };
  },
  filters: {
    ThousandSeparator: function ThousandSeparator(input) {
      return input && input.toString().replace(/(^|\s)\d+/g, function (m) {
        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
      });
    }
  },
  created: function created() {
    // this.init()
    this.startTraining(true); // 当前数据状态
  },

  methods: {
    init: function init() {
      var _this = this;
      sentPayslipInfo({
        payslip_id: this.query.payslip_id
      }).then(function (res) {
        if (res && res.code === 1) _this.payslipInfo = res.data.payslip_info;
      });
      this.sentPayslipStaffList();
    },
    sentPayslipStaffList: function sentPayslipStaffList() {
      var _this2 = this;
      _sentPayslipStaffList(this.query).then(function (res) {
        if (res && res.code === 1) _this2.tableData = res.data;
      });
    },
    // 重新发送
    sendHandle: function sendHandle() {
      var _this3 = this;
      afreshSendErrStaff({
        payslip_id: this.query.payslip_id
      }).then(function (res) {
        if (res && res.code) {
          _this3.payState.state = 1;
          _this3.tableData = [];
          _this3.payslipInfo.send_fail_count = 0;
          _this3.payslipInfo.send_success_count = 0;
          var clearTime = null;
          _this3.startTraining1(true, clearTime);
        }
      });
    },
    // 开始轮训
    startTraining1: function startTraining1(type, clearTime) {
      if (!type) {
        // 为false 关闭定时器
        clearTimeout(clearTime);
        return;
      }
      var this_ = this;
      function timerFn() {
        return _timerFn.apply(this, arguments);
      }
      function _timerFn() {
        _timerFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // 获取子项目状态
                getAfreshSendStatus({
                  payslip_id: this_.query.payslip_id
                }).then(function (res) {
                  if (!res.data.state) clearTime = setTimeout(timerFn, 5000);else {
                    this_.init();
                    this_.payState.state = 0;
                    clearTimeout(clearTime);
                  }
                }).catch(function () {
                  this_.payState.state = 0;
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return _timerFn.apply(this, arguments);
      }
      timerFn();
    },
    startTraining: function startTraining(type) {
      // 开始轮训
      if (!type) {
        // 为false 关闭定时器
        return clearTimeout(this.clearTime);
      }
      var this_ = this;
      function timerFn() {
        return _timerFn2.apply(this, arguments);
      }
      function _timerFn2() {
        _timerFn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var res;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getPayslipSentState({
                  payslip_id: this_.query.payslip_id
                });
              case 2:
                res = _context2.sent;
                if (res && res.code === 1) {
                  this_.payState.state = Number(res.data.state);
                  this_.payState.is_self_task = Number(res.data.is_self_task);
                }
                // state: 1,2为计算中状态 state为1停留在该页面接口一直请求 直到状态改为0
                if (this_.payState.state === 1) this_.clearTime = setTimeout(timerFn, 5000);
                if (!this_.payState.state) this_.init();
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _timerFn2.apply(this, arguments);
      }
      timerFn();
    },
    handlerBack: function handlerBack() {
      var query = {
        active: this.$route.query.active
      };
      if (this.$route.query.month2) query.month2 = this.$route.query.month2;
      if (this.$route.query.month3) query.month3 = this.$route.query.month3;
      this.$router.push({
        path: '/payroll/pay-slip',
        query: query
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 停止轮训
    this.startTraining(false);
    this.startTraining1(false);
  }
};